<template>
  <el-dialog
    :visible.sync="visible"
    :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="25%"
  >
    <div class="handle-content">
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="rules"
        class="demo-form-inline"
      >
        <el-form-item label="处理结果" :label-width="'90px'" prop="action">
          <el-select
            v-model="dataForm.action"
            placeholder="请选择"
            :style="{ width: '315px' }"
          >
            <el-option label="已维修，完结" :value="1"></el-option>
            <el-option label="已维修，更换设备编号，完结" :value="2"></el-option>
            <el-option label="无法维修，完结" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号" v-if="dataForm.action === 2" :label-width="'90px'" prop="newSn">
          <el-input v-model="dataForm.newSn" :style="{ width: '315px' }" placeholder="设备编号" clearable/>
        </el-form-item>
        <el-form-item 
          label="说明"
          :label-width="'90px'"
          prop="remark"
        >
          <el-input type="textarea" placeholder="说明" v-model="dataForm.remark" :style="{ width: '315px' }"/>
        </el-form-item>
      </el-form>
    </div>
    <template slot="footer">
      <el-button type="primary" :loading="loading" @click="dataFormSubmitHandle()">确认</el-button>
      <el-button @click="visible = false">取消</el-button>
    </template>
  </el-dialog>
</template>
<script>
import axios from "@/utils/axios";
export default {
  data() {
    return {
      title: null,
      loading: false,
      dataForm: {
        cloudId: null,
        action: null,
        sn: null,
        nextPerson: null,
        suggest: null,
        remark: null,
        cloudId: null,
        faultTime: null,
        orgCode: null,
        organId: null,
        id: null,
      },
      visible: false,
    };
  },
  computed: {
    rules() {
      return {
        action: [
          { required: true, message: "必填项不能为空", trigger: "change" },
        ],
        newSn: [
          { required: true, message: "必填项不能为空", trigger: "bulr" },
        ],
        remark: [
          { required: true, message: "必填项不能为空", trigger: "bulr" },
        ],
      };
    },
  },
  methods: {
    //初始化
    init() {
      this.visible = true;
      this.dataForm.organId = localStorage.getItem('organId')
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
      });
    },
    dataFormSubmitHandle() {
      this.$refs["dataForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true
        axios
          .post(`/api/postSale/deal`, this.dataForm)
          .then(res => {
            if (res) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false;
                  this.$emit("refreshDataList");
                },
              });
              this.loading = false
            }
          })
          .catch((err) => {
            this.loading = false
            return this.$message.error(err);
          });
      });
    },
  },
};
</script>